import { NextPageContext } from "next"
import { parse, serialize } from "cookie"
import { ABTestCookieName, experimentIds, ExperimentTag } from "../experiments"
import { decodeHistory, encodeHistory } from "../history"
import { CookieStore } from "./handler"

export class NextCookieStore implements CookieStore {
    constructor(private readonly ctx: NextPageContext) {
        this.ctx = ctx
    }

    load = (): ExperimentTag[] => {
        const raw = parse(this.ctx.req?.headers.cookie || "", {
            decode: (encodedString) => {
                try {
                    return decodeURIComponent(encodedString)
                } catch (e) {
                    console.log("unable to decode cookie", e)
                    return ""
                }
            },
        })[ABTestCookieName]

        try {
            return decodeHistory(experimentIds, raw || "")
        } catch (_e) {
            return []
        }
    }

    store = (history: ExperimentTag[]) => {
        if (!this.ctx.res) return

        const setCookie = serialize(ABTestCookieName, encodeHistory(history), {
            path: "/",
            maxAge: 60 * 60 * 24 * 30, // 30 days
        })
        this.ctx.res.setHeader("Set-Cookie", setCookie)
    }
}
